import { render, staticRenderFns } from "./ShowContactCRM.vue?vue&type=template&id=4c22b8cc&scoped=true"
import script from "./ShowContactCRM.vue?vue&type=script&lang=js"
export * from "./ShowContactCRM.vue?vue&type=script&lang=js"
import style0 from "./show-contact-crm.scss?vue&type=style&index=0&id=4c22b8cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c22b8cc",
  null
  
)

export default component.exports